import request from '@/utils/request'

//赊还统计
export const credit_Acount = (data) => {
    return request({
      url: '/erp-pos/statistics/get-credit-buyers',
      method: 'post',
      data
    })
  }

  //赊还统计详情
  export const credit_Acount_Detail = (data) => {
    return request({
      url: '/erp-pos/statistics/get-credit-buyers-details',
      method: 'post',
      data
    })
  }